import React, { Fragment, useLayoutEffect } from "react";
import ContactSection from "../../components/ContactSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/Help-Desk-Components/Footer/Footer";
import HeaderBuga from "../../components/header6/Header6";
import { useLocation } from "react-router-dom";

const ContactUsPage = (props) => {
       const { pathname } = useLocation();
    useLayoutEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />
        <section
          className="page-title pt-100  pos-rel bg_img breadcrums-bgr"
          //   style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <h2 className="title">
                      Contact Us <br />
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ContactSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ContactUsPage;
